import React from "react";
import { useEffect, useState } from "react";

function AccordionMenu({
  favDepartments,
  setFavDepartments,
  favoriteDepartmentTrigger,
  setFavoriteDepartmentTrigger,
}) {
  // Favori üniversiteleri localStorage'da saklamak için anahtar
  const localStorageKey = "favoriteUniversities";

  // Favori üniversiteyi silmek için fonksiyon
  const deleteFavoriteDepartment = (university) => {
    var storedFavorites = localStorage.getItem(localStorageKey);
    if (storedFavorites) {
      const favorites = JSON.parse(storedFavorites);
      const newFavorites = favorites.filter(
        (item) => item.uni_department !== university.uni_department
      );
      localStorage.setItem(localStorageKey, JSON.stringify(newFavorites));
    }
    // Trigger state'i güncelleyerek useEffect'i tetikle
    setFavoriteDepartmentTrigger(favoriteDepartmentTrigger + 1);
  };

  useEffect(() => {
    const storedFavorites = localStorage.getItem(localStorageKey);
    if (storedFavorites) {
      setFavDepartments(JSON.parse(storedFavorites));
    }
  }, [favoriteDepartmentTrigger]);

  return (
    <div
      className="position-fixed favorite-departments"
      
    >
      <div className="accordion " id="accordionExample">
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button text-center"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              ariaExpanded="false"
              aria-controls="collapseOne"
            >
              Favori Bölümlerim
            </button>
          </h2>
          <div
            id="collapseOne"
            className="accordion-collapse collapse show"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <table className="table table-dark table-striped">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Bölüm</th>
                    <th colSpan="3">Detaylar</th>
                    <th scope="col">+</th>
                  </tr>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col">Kota</th>
                    <th scope="col">Puan</th>
                    <th scope="col">Sıralama</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  {favDepartments.map((university, index) => (
                    <tr key={index}>
                      <th scope="row">{index + 1}</th>
                      <td>{university.uni_department}</td>
                      <td>{university.quota}</td>
                      <td>{university.p2022}</td>
                      <td>{university.s2022}</td>
                      <td>
                        <button
                          onClick={() => deleteFavoriteDepartment(university)}
                          className="btn btn-danger"
                        >
                          -
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccordionMenu;
